import React from 'react';
import { Button, Result } from 'antd';

class AppErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Uncaught application render error', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <Result
        status="error"
        title="This page could not be displayed"
        subTitle="Your work is still safe. Reload the page, and contact support if the problem continues."
        extra={[
          <Button type="primary" key="reload" onClick={() => window.location.reload()}>
            Reload page
          </Button>,
          <Button key="home" onClick={() => { window.location.href = '/'; }}>
            Return home
          </Button>
        ]}
      />
    );
  }
}

export default AppErrorBoundary;

